export default "__VITE_ASSET__W_1$_0RL__"